import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { addFollowingFriend } from "../../../actions/friend";
import { acceptedCasualNotification } from "../../../actions/notification";

const AddMentorCasualRequest = ({
  match,
  addFollowingFriend,
  acceptedCasualNotification,
  setmentorrequestcasual,
  profile: { user, avatar, firstname, lastname, jobtitle, location },
}) => {
  return (
    <Fragment>
      <div className="messages-overlay">
        <div className="request-box">
          <i
            className="fas fa-times fa-3x message-x"
            onClick={() =>
              setmentorrequestcasual({ request: false, confirm: false })
            }
          ></i>
          <div className="flex-center">
            <div className="online-avi-container">
              <div className="avi-color-border red">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                  className="drop-down-result-avi"
                  alt="avatar"
                />
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="red name-font bold">
                    {firstname} {lastname}
                  </span>
                </li>
                <li className="user-online-item">{jobtitle}</li>
                <li className="user-online-item">
                  {location.city}, {location.state}
                </li>
              </ul>
            </div>
          </div>
          <div className="user-request-text">
            <span className="red bold">
              {firstname} {lastname}{" "}
            </span>
            currently follows you, would you like to add this user as a friend?
          </div>
          <div className="flex-center">
            <button
              className="user-request-button background-red"
              onClick={() =>
                addFollowingFriend({ user }) &&
                acceptedCasualNotification(match.params.channelid) &&
                setmentorrequestcasual({ request: false, confirm: true })
              }
            >
              <i className="far fa-check-circle fa-sm mr-5"></i>
              Confirm
            </button>
            <button
              className="user-request-button background-red"
              onClick={() =>
                setmentorrequestcasual({ request: false, confirm: false })
              }
            >
              <i className="fas fa-times fa-sm mr-5 bold"></i>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

AddMentorCasualRequest.propTypes = {
  auth: PropTypes.object.isRequired,
  addFollowingFriend: PropTypes.func.isRequired,
  acceptedCasualNotification: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  friend: state.friend,
});

export default connect(mapStateToProps, {
  addFollowingFriend,
  acceptedCasualNotification,
})(AddMentorCasualRequest);
